var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tour',{attrs:{"name":"mainTour","steps":_vm.tour_steps,"options":_vm.tour_options,"callbacks":_vm.tour_callbacks}}),_c('MyPostTour')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }